// mutations.js

//import moment from "../../../plugins/moment";
import moment from "moment-timezone";

export default {
    updateMessagesFields(state){
        if(!state.isFieldsUpdated){
            console.log('Обновляем филды')
            let fields = []
            state.messages.forEach(data=>{
                data.data.forEach(field=>{
                    let item = {
                        name: field.name,
                        type: field.type,
                        dynamic: field.dynamic,
                        value: field.value,
                        val_str: field.val_str,
                        uom: field.uom,
                    }
                    let listValue = null
                    if(typeof field.val_str === 'object'){
                        listValue = field.val_str[field.value]
                        item.value = listValue
                    }
                    if(field.uom){
                        item.value = field.value + field.uom
                    } else{
                        item.value = field.value
                    }
                    if(typeof field.value === 'string'){
                        item.dynamic = false
                    }
                    let fieldInList = fields.find(insideField=> insideField.name === item.name)
                    //console.log(item, fieldInList)
                    if(!fieldInList){
                        fields.push(item)
                    } else {
                        fieldInList.value = listValue ? listValue : item.value
                    }
                })
            })
            state.fields = fields
            state.isFieldsUpdated = true
        }
    },
    updateMessages(state, payload){
        state.currentPage = payload.current_page
        state.lasPage = payload.last_page
        state.isSearchDone = payload.current_page >= payload.last_page
        if(payload.current_page === 1){
            state.messages = []
        }
        payload.data.forEach(dataItem=>{
            dataItem.created_at = moment(dataItem.created_at).format('YYYY-MM-DDTHH:mm:ss.SSS') + '000Z'
            dataItem.updated_at = moment(dataItem.updated_at).format('YYYY-MM-DDTHH:mm:ss.SSS') + '000Z'
            state.messages.push(dataItem)
        })
        if(state.isSearchDone){
            console.log('Сортируем')
            state.messages = state.messages.sort((a,b)=>{ //Сортируем по времени
                return moment(a.created_at).format('X') - moment(b.created_at).format('X')
            })
        }
    },
    updateLastDevicesMessages(state, payload){
        state.lastDevicesMessages = payload
    },
    updateLastDevice(state, payload){
        let newData = payload[0]
        let updatedValue = state.lastDevicesMessages.find(item=>item.device_id === newData.device_id)
        if(updatedValue){
            console.log('апдейтим ', newData)
            updatedValue.data.forEach(dataItem=>{
                let newValue = newData.data.find(item=>item.name === dataItem.name)
                if(dataItem.value !== newValue.value){
                    console.log('ставим значение ', dataItem.name, newValue.value)
                    dataItem.value = newValue.value
                }
            })
            // state.lastDevicesMessages.slice(updatedValueIndex, 1)
            // state.lastDevicesMessages.push(newValue)
        }
    },
    updateIsFieldsUpdated(state, payload){
        state.isFieldsUpdated = payload
    },
    updateClearFields(state){
        state.fields = []
    },
    updateClearMessages(state){
        state.messages = []
    },
    updateSelectedFields(state, payload) {
        state.selectedFields = payload
    }
};
